import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../../../../modules/infra/ui/button';
import { t } from '../../../../modules/infra/i18n';
export var WalkInListLinkOnly = function (_a) {
    var onOpenWalkInList = _a.onOpenWalkInList;
    return (_jsx(Button.Outline, { type: "button", className: "u-ml-", onClick: onOpenWalkInList, children: t('appointment:waiting_list.walk_in_list') }));
};
